export default __webpack_public_path__ + "static/media/gold.56a79897.svg";